import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="filter-dropdown"
export default class extends Controller {
  static targets = ["menu", "arrow", "button", "indicator"]

  connect() {
    this.outsideClickHandler = this.outsideClick.bind(this)
    document.addEventListener("click", this.outsideClickHandler)
    this.updateIndicator()
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClickHandler)
  }

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")
    this.rotateArrow()
  }

  rotateArrow() {
    this.arrowTarget.classList.toggle('rotate-180')
  }

  outsideClick(event) {
    if (!this.buttonTarget.contains(event.target) && !this.menuTarget.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
      this.arrowTarget.classList.remove('rotate-180')
    }
  }

  updateIndicator() {
    const params = new URLSearchParams(window.location.search)
    
    const hasNonDefaultFilters = 
      (params.get('modelable_public_id') && params.get('modelable_public_id') !== '') ||
      (params.get('sort') && params.get('sort') !== 'desc') ||
      params.get('filter') === 'favorited'
    
    this.indicatorTarget.classList.toggle('hidden', !hasNonDefaultFilters)
  }

  clearFilters(event) {
    event.preventDefault()
    window.location.href = this.element.dataset.defaultUrl || '/'
  }
} 